import React from 'react';

const EditorHeader = ({ title }) => {
  return (
    <header className="AssignmentResultsHeaderDesktop">
      <div className="ahd__title_bar">
        <div className="assignment_title">
          <h1 className="ahd__title font-heading mb-12">{title}</h1>
        </div>
      </div>
    </header>
  );
};
EditorHeader.defaultProps = {
  qbPath: '',
  title: '',
};

export default EditorHeader;
